import React, { useContext } from 'react';
import * as R from 'ramda';
import { bool, func } from 'prop-types';

// Components
import { Box } from '@mui/material';
import Buttons from '../../components/Buttons';
import LocationCheckboxList from '../../components/LocationCheckboxList.connector';
import SummaryDrawer from '../../components/SummaryDrawer';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const SequenceStep3 = ({ loading, next, prev }) => {
  const {
    data: { locations = [], products = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const continueDisabled = R.isEmpty(locations);
  const handleChange = R.o(setData, R.assoc('locations'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          // Prevents bottom selection from clipping on Y overflow
          marginBottom: 46,
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <LocationCheckboxList
            locations={locations}
            onChange={handleChange}
            products={products}
            title="Select one or more locations where products are available"
          />
        </Box>
        <SummaryDrawer displayProducts inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={loading}
        rightLabel="Continue"
      />
    </>
  );
};

SequenceStep3.propTypes = {
  loading: bool.isRequired,
  next: func.isRequired,
  prev: func.isRequired,
};

export default SequenceStep3;
